import { AnchorIcon, CompassIcon } from '@/components/game/GameIcons'

const BTN =
  'grid place-items-center w-9 h-9 rounded-lg bg-ocean-900/85 border border-sand-500/25 ' +
  'text-sand-200 hover:text-sand-100 hover:border-sand-300/50 transition-colors backdrop-blur-sm shadow-lg'

/**
 * Barre de contrôles carte (présentational — les actions RZPP sont injectées par
 * le parent). Plein écran · (dé)masquer les tracés de missions · zoom + · zoom − ·
 * recentrer sur mon île. Une puce d'aide gestuelle s'affiche une fois sur mobile.
 *
 * ⚠️ Rangée HORS du plateau, jamais en overlay dessus : le blueprint pose une île
 * sur chacun des quatre coins de la grille (repaires apex 5/5, 95/5, 5/95, 95/95)
 * et sur chaque milieu de bord (les quatre récifs). Un cluster posé dans un coin
 * du cadre avalait donc forcément un marqueur, et le déplacer d'un coin à l'autre
 * n'y changeait rien. C'est le parent qui la positionne.
 */
export function MapControls({
  onZoomIn,
  onZoomOut,
  onRecenter,
  onToggleFullscreen,
  isFullscreen,
  showHint,
  showTraces,
  onToggleTraces,
}: {
  onZoomIn: () => void
  onZoomOut: () => void
  onRecenter: () => void
  onToggleFullscreen: () => void
  isFullscreen: boolean
  showHint: boolean
  /** Les tracés de missions sont-ils affichés ? (reflété via aria-pressed) */
  showTraces: boolean
  /** Bascule l'affichage des tracés de missions sur la carte. */
  onToggleTraces: () => void
}) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-1.5">
      {showHint && (
        <div className="mr-auto rounded-lg bg-ocean-900/85 border border-sand-500/25 px-2.5 py-1 text-[11px] text-ocean-100 backdrop-blur-sm shadow-lg">
          Pince pour zoomer · glisse pour te déplacer
        </div>
      )}
      <button
        type="button"
        className={BTN}
        onClick={onToggleFullscreen}
        aria-label={isFullscreen ? 'Quitter le plein écran' : 'Plein écran'}
        title={isFullscreen ? 'Quitter le plein écran' : 'Plein écran'}
      >
        <span aria-hidden="true">{isFullscreen ? '⤡' : '⤢'}</span>
      </button>
      <button
        type="button"
        className={`${BTN} ${showTraces ? '' : 'opacity-50'}`}
        onClick={onToggleTraces}
        aria-pressed={showTraces}
        aria-label={showTraces ? 'Masquer les tracés de missions' : 'Afficher les tracés de missions'}
        title={showTraces ? 'Masquer les tracés de missions' : 'Afficher les tracés de missions'}
      >
        <CompassIcon className="w-4 h-4" />
      </button>
      <button type="button" className={BTN} onClick={onZoomIn} aria-label="Zoom avant" title="Zoom avant">
        +
      </button>
      <button type="button" className={BTN} onClick={onZoomOut} aria-label="Zoom arrière" title="Zoom arrière">
        −
      </button>
      <button type="button" className={BTN} onClick={onRecenter} aria-label="Recentrer sur mon île" title="Recentrer sur mon île">
        <AnchorIcon className="w-4 h-4" />
      </button>
    </div>
  )
}
